<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới khóa học</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="image" label="Ảnh khóa học">
              <el-upload
                class="course-uploader"
                :action="upload.url"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="modelData.image_path" :src="modelData.image_path" class="course">
                <i v-else class="el-icon-plus course-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh khóa học có dung lượng tối đa tải lên là 2Mb
                </div>
              </el-upload>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Tên khóa học" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
                </el-form-item>
                <el-form-item prop="price" label="Giá Khoai" class="form-item">
                  <el-input type="age" v-model.number="modelData.price" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="category_course_id" label="Lĩnh vực khóa học" class="form-item">
                  <el-select v-model="modelData.category_course_id" filterable clearable placeholder="Lĩnh vực khóa học" class="input-select">
                    <el-option
                      v-for="item in lists.listCategoryCourse"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="teacher_id" label="Giảng viên" class="form-item">
                  <el-select v-model="modelData.teacher_id" filterable clearable placeholder="Giảng viên" class="input-select">
                    <el-option
                      v-for="item in lists.listTeacher"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="sale" label="Phần trăm giảm giá" class="form-item">
                  <el-input type="age" v-model.number="modelData.sale" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="date_start" label="Ngày bắt đầu giảm giá" class="form-item input-daterange">
                  <el-date-picker
                    v-model="modelData.date_start"
                    type="date"
                    id="date_start"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="Ngày bắt đầu giảm giá">
                  </el-date-picker>
                </el-form-item>
                <el-form-item prop="date_end" label="Ngày kết thúc giảm giá" class="form-item input-daterange">
                  <el-date-picker
                    v-model="modelData.date_end"
                    type="date"
                    id="date_end"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="Ngày kết thúc giảm giá">
                  </el-date-picker>
                </el-form-item>
                <el-form-item prop="date_use" label="Số ngày sử dụng khóa học" class="form-item">
                  <el-input type="age" v-model.number="modelData.date_use" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="content" label="Nội dung khóa học">
              <tinymce
                id="d1"
                v-model="modelData.content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '500px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import ls from 'local-storage'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'CourseCreate',
  metaInfo () {
    return {
      title: 'Khóa học | Thêm'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        category_course_id: '',
        teacher_id: '',
        image: '',
        image_path: '',
        price: '',
        content: '',
        sale: '',
        date_start: '',
        date_end: '',
        date_use: '',
        status: true
      },
      lists: {
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listTeacher: [
          {key: 0, value: 'Chọn giảng viên'}
        ]
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'courses/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên khóa học' },
          { min: 2, max: 191, message: 'Tên khóa học có chiều dài từ 2 tới 191 kí tự' }
        ],
        price: [
          { required: true, message: 'Vui lòng nhập giá khóa học' },
          { type: 'number', message: 'Giá khóa học phải là kiểu số' }
        ],
        category_course_id: [
          { required: true, message: 'Vui lòng nhập lĩnh vực khóa học' }
        ],
        teacher_id: [
          { required: true, message: 'Vui lòng nhập giảng viên của khóa học' }
        ],
        image: [
          { required: true, message: 'Vui lòng upload ảnh của khóa học' }
        ],
        date_use: [
          { required: true, message: 'Vui lòng nhập số ngày sử dụng của khóa học' },
          { type: 'number', message: 'Số ngày sử dụng của khóa học phải là kiểu số' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    this.configUpload()
    this.fetchListCategoryCourse()
    this.fetchListTeacher()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      // let formData = new FormData()
      // formData.append('file', file.blob())
      // let response = await axios.post('courses/upload', formData)
      // if (response.code === 1) {
      //   success(response.data.path)
      // } else {
      //   return false
      // }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'courses-index'})
    },
    // Fetch dữ liệu về lĩnh vực khóa học
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      axios.get('users', {params: {'status': 1, 'system_manager': 0, 'user_type': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('courses', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm tài khoản thành công',
              type: 'success'
            })
            this.$router.push({name: 'courses-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh khóa học có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.image = response.data.name
        this.modelData.image_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.course {
  width: 280px;
  height: 200px;
  display: block;
}
</style>

<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/Create.vue